import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import type { ExampleGroup } from './assistantChatConfigs';

type Props = {
  open: boolean;
  onClose: () => void;
  examples: ExampleGroup[];
  initialTab?: number;
  onPick: (prompt: string) => void;
};

function AssistantChatExamplesDialog({ open, onClose, examples, initialTab = 0, onPick }: Props) {
  const [activeTab, setActiveTab] = useState(
    Math.min(initialTab, Math.max(examples.length - 1, 0))
  );
  const groups = examples.length > 0 ? examples : [{ id: 'none', label: 'Examples', prompts: [] }];
  const active = groups[activeTab] || groups[0];

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      className="ac-examples-dialog"
    >
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', pr: 1 }}>
        <span>Example prompts</span>
        <IconButton onClick={onClose} size="small" aria-label="Close">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pt: 0 }}>
        {groups.length > 1 && (
          <div className="ac-examples-tabs" role="tablist">
            {groups.map((g, i) => (
              <button
                key={g.id}
                role="tab"
                aria-selected={i === activeTab}
                className={`ac-examples-tab${i === activeTab ? ' active' : ''}`}
                onClick={() => setActiveTab(i)}
                type="button"
              >
                {g.icon}
                {g.label}
              </button>
            ))}
          </div>
        )}
        <div className="ac-examples-list">
          {active.prompts.length === 0 ? (
            <div style={{ color: 'var(--ac-text-muted, #6b7280)', fontSize: '0.9rem', padding: '12px 0' }}>
              No examples available.
            </div>
          ) : (
            active.prompts.map((prompt, idx) => (
              <button
                key={idx}
                type="button"
                className="ac-example-item"
                onClick={() => {
                  onPick(prompt);
                  onClose();
                }}
              >
                {prompt}
              </button>
            ))
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}

export default AssistantChatExamplesDialog;
